// ABOUTME: Readable names for links: the hostname helper, and the label shown for a link.
// ABOUTME: A link saved without a name stores its URL as the name, so display cleans it up.

/** The hostname without a leading "www.", or "" when the input is not a URL. */
export function domainOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return "";
  }
}

/** A URL as a person would read it: no protocol, no www, no query or fragment. */
export function readableAddress(url: string): string {
  try {
    const parsed = new URL(url);
    const host = parsed.hostname.replace(/^www\./, "");
    const path = parsed.pathname.replace(/\/+$/, "");
    return host + path;
  } catch {
    return url;
  }
}

/**
 * True when the user gave the link no name. Both add paths store the URL as the
 * name in that case, so a name equal to the URL counts as none.
 */
export function isUnnamed(link: { name?: string; url?: string }): boolean {
  const name = link.name?.trim() ?? "";
  return !name || name === link.url;
}

/** The name to show for a link: its own name, or a readable address when it has none. */
export function linkLabel(link: { name?: string; url?: string }): string {
  if (!isUnnamed(link)) return link.name!.trim();
  if (link.url) return readableAddress(link.url);
  return link.name?.trim() ?? "";
}
